import Typography from "@mui/material/Typography";

import { useRemoveCompaniesFromTechnologyQuery } from "@queries/portfolio.query";

import { PopupActions } from "@store/popupStore";

interface IUseRemoveCompaniesProperties {
  companyIds: string[];
  name: string;
  technologyId: string;
}

const useRemoveCompanies = () => {
  const { mutateAsync: removeCompaniesFromTechnology } = useRemoveCompaniesFromTechnologyQuery();
  return ({ companyIds, name, technologyId }: IUseRemoveCompaniesProperties) => {
    PopupActions.openConfirmation({
      content: (
        <Typography
          sx={{
            mt: 1,
          }}
        >
          {" "}
          Are you sure you would like to remove{" "}
          {companyIds.length > 1 ? `${companyIds.length} companies` : "this company"} from <strong>{name}</strong>?
        </Typography>
      ),
      onConfirm: () => {
        void removeCompaniesFromTechnology({
          companyIds,
          technologyId,
        });
      },
      title: "Remove from Technology",
    });
  };
};

export default useRemoveCompanies;
